/** Tooltip copy for KPI tiles and summary bands — presentation only. */

export const DASHBOARD_KPI_HELP = {
  learners: 'The number of unique people enrolled in your courses. Shown as enrolled / your plan limit; the bar is how much of that limit is used.',
  activeCourses: 'Courses you have created and published. Shown as published / your plan limit; the bar is how much of that limit is used.',
  assessments: 'Total tests and quizzes created across all your courses. Shown as created / your plan limit; the bar is how much of that limit is used.',
  avgScore: 'Mean percentage your learners scored across all graded submissions. A higher value means stronger overall performance.',
};

export const COURSE_DETAIL_KPI_HELP = {
  learners: 'Total learners currently enrolled in this course.',
  assessments: 'Graded assessments linked to this course.',
  avgCompletion: 'Average progress across enrolled learners — how far the cohort has moved through course content.',
  avgScore: 'Mean score percentage across graded submissions for this course.',
};

export const ASSESSMENT_DETAIL_KPI_HELP = {
  questions: 'Total questions currently in this assessment.',
  duration: 'Time limit learners have to complete the assessment, in minutes.',
  totalMarks: 'Maximum points available across all questions in this assessment.',
  domains: 'Number of content domains and subdomains this assessment covers.',
};

export const GRADE_CENTER_KPI_HELP = {
  averageScore: 'Mean percentage across all graded submissions in the current filter (course, assessment, or learner).',
  passRate: 'Share of submissions that met the passing threshold for their assessment.',
  topScore: 'Highest percentage achieved by any learner in the current filter.',
  scoreDistribution: 'How many submissions fall into each score band — shows whether results cluster high, middle, or low.',
  highestScoring: 'Learners ranked by average score across their submissions in the current filter.',
};
